const NoPage = () => {
    return (
        <div className="bg-gray-500">
            <h1>404 - Page Not Found</h1>
        </div>
    )
}

export default NoPage;